<template lang="pug">
.main-nav
  debugTools
  ul.nav.d-flex.justify-content-start.align-items-center.h-100
    li.nav-item
      a.nav-link(href="javascript:void(0);", @click="setMenu2(1)")
        img.icon-menu(src="/images/menu/sport.png")
        img.icon-menu-hover(src="/images/menu/sport_hover.png")
        span {{ $t('ui.sports') }}

    li#casino.nav-item(v-if="!whiteLabel")
      a#casino-menu.nav-link.hover-drop(href="javascript:void(0);", data-toggle="dropdown", aria-haspopup="true", aria-expanded="false")
        img.icon-menu(src="/images/menu/casino.png")
        img.icon-menu-hover(src="/images/menu/casino_hover.png")
        span {{ $t('ui.casino') }}
      .dropdown-menu.group-hover(aria-labelledby="casino-menu")
        //--------------------------------------------------------------------
        //- Casino
        //--------------------------------------------------------------------
        .product-wrap(v-for="row in casinoList")
          .product(v-for="item in row")
            router-link.suit-wrap(
              :to="item.toPath",
              target="_blank",
              :onclick="item.popup",
            )
              .suit-image
                img(:src="item.thumbnail")
                .suit-overlay
                  .play-now {{ $t('ui.play_now') }}
              .suite {{ $t(item.title) }}

          //- //- AI Casino
          //- //-
          //- .product(v-if="!mmoMode")
          //-   router-link.suit-wrap(
          //-     to="/casino?suite=10",
          //-     target="_blank",
          //-     onclick="window.open(this.href,'casino10','top=10,height=800,width=450,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-   )
          //-     .suit-image
          //-       img(src="/img/lobby/casino-ai.png?v=4")
          //-       .suit-overlay
          //-         .play-now {{ $t('ui.play_now') }}
          //-     .suite {{ $t('ui.ai_casino') }}

          //- //- Pragmatic Casino
          //- .product(v-if="!mmoMode && newFeatures")
          //-   router-link.suit-wrap(
          //-     to="/casino?suite=9",
          //-     target="_blank",
          //-     onclick="window.open(this.href,'casino9','top=10,height=500,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-   )
          //-     .suit-image
          //-       img(src="/img/lobby/casino-pragmatic.png?v=4")
          //-       .suit-overlay
          //-         .play-now {{ $t('ui.play_now') }}
          //-     .suite {{ $t('ui.london_suite') }}

          //- //- Yee Bet
          //- .product(v-if="!mmoMode")
          //-   router-link.suit-wrap(
          //-     to="/casino?suite=8",
          //-     target="_blank",
          //-     onclick="window.open(this.href,'casino8','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-   )
          //-     .suit-image
          //-       img(src="/img/lobby/casino-yeebet.png?v=4")
          //-       .suit-overlay
          //-         .play-now {{ $t('ui.play_now') }}
          //-     .suite {{ $t('ui.yeebet_suite') }}

          //- //- CT855
          //- template(v-if="brand != 'IBCBET'")
          //-   .product(v-if="!mmoMode")
          //-     router-link.suit-wrap(
          //-       to="/casino?suite=4",
          //-       target="_blank",
          //-       onclick="window.open(this.href,'casino4','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-     )
          //-       .suit-image
          //-         img(src="/img/lobby/casino-ct855.png?v=4")
          //-         .suit-overlay
          //-           .play-now {{ $t('ui.play_now') }}
          //-       .suite {{ $t('ui.vietnam_suite') }}

          //- //- Gameplay
          //- .product(v-if="!mmoMode")
          //-   router-link.suit-wrap(
          //-     to="/casino?suite=1",
          //-     target="_blank",
          //-     onclick="window.open(this.href,'casino1','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-   )
          //-     .suit-image
          //-       img(src="/img/lobby/casino-gameplay.png?v=4")
          //-       .suit-overlay
          //-         .play-now {{ $t('ui.play_now') }}
          //-     .suite {{ $t('ui.manila_suite') }}

          //- //- SA Gaming
          //- .product(v-if="!mmoMode && sacasino")
          //-   router-link.suit-wrap(
          //-     to="/casino?suite=3",
          //-     target="_blank",
          //-     onclick="window.open(this.href,'casino3','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-   )
          //-     .suit-image
          //-       img(src="/img/lobby/casino-sagaming.png?v=4")
          //-       .suit-overlay
          //-         .play-now {{ $t('ui.play_now') }}
          //-     .suite {{ $t('ui.bangkok_suite') }}

          //- //- Evolution
          //- template(v-if="brand != 'IBCBET'")
          //-   .product(v-if="!mmoMode")
          //-     router-link.suit-wrap(
          //-       to="/casino?suite=5",
          //-       target="_blank",
          //-       onclick="window.open(this.href,'casino5','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-     )
          //-       .suit-image
          //-         img(src="/img/lobby/casino-evo.png?v=4")
          //-         .suit-overlay
          //-           .play-now {{ $t('ui.play_now') }}
          //-       .suite {{ $t('ui.vegas_suite') }}

          //- //- Pretty Gaming
          //- .product(v-if="!mmoMode")
          //-   router-link.suit-wrap(
          //-     to="/casino?suite=7",
          //-     target="_blank",
          //-     onclick="window.open(this.href,'casino7','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
          //-   )
          //-     .suit-image
          //-       img(src="/img/lobby/casino-pretty-gaming.png?v=4")
          //-       .suit-overlay
          //-         .play-now {{ $t('ui.play_now') }}
          //-     .suite {{ $t('ui.phnom_penh_suite') }}

    li#slots.nav-item(v-if="!whiteLabel")
      a#slots-menu.nav-link.hover-drop(href="javascript:void(0);", data-toggle="dropdown", aria-haspopup="true", aria-expanded="false")
        img.icon-menu(src="/images/menu/slot.png")
        img.icon-menu-hover(src="/images/menu/slot_hover.png")
        span {{ $t('ui.slots') }}
      .dropdown-menu.group-hover(aria-labelledby="slots-menu")
        //--------------------------------------------------------------------
        //- Slots
        //--------------------------------------------------------------------
        .product-wrap(v-for="row in slotsList")
          .product(v-for="item in row")
            router-link.suit-wrap(
              :to="item.toPath",
              target="_blank",
              :onclick="item.popup",
            )
              .suit-image
                img(:src="item.thumbnail")
                .suit-overlay
                  .play-now {{ $t('ui.play_now') }}
              .suite {{ $t(item.title) }}

        //- .product-wrap(v-for="row in slotsList")
        //-   template(v-for="item in row")
        //-     .product(v-if="!item.isHidden && mmoMode == item.isSupportMMO && (item.isNewFeatures ? newFeatures : true) && !item.exclude.includes(brand)")
        //-       router-link.suit-wrap(
        //-         :to="item.toPath",
        //-         target="_blank",
        //-         :onclick="item.popup",
        //-       )
        //-         .suit-image
        //-           img(:src="item.thumbnail")
        //-           .suit-overlay
        //-             .play-now {{ $t('ui.play_now') }}
        //-         .suite {{ $t(item.title) }}

        //- .product-wrap
        //-   //- EpicWin
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots14",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots14','top=10,height=594,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-epicwin.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.epicwin') }}

        //-   //- WF Gaming
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots13",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots13','top=10,height=594,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-wf.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.wf_gaming') }}

        //-   //- WOW Gaming
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots11",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots11','top=10,height=800,width=480,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-wow.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.wow_gaming') }}

        //-   //- Live22
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots12",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots12','top=10,height=594,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-live22.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.live22') }}

        //-   //- DBHASH
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots9",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots9','top=10,height=800,width=480,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-dbhash.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.dbhash') }}
        //-   //- UUSL
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK', 'VND'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots7",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots7','top=10,height=658,width=1200,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-uuslots.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.uusl') }}
        //-   //- NEXTSPIN
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots8",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots8','top=10,height=658,width=1200,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-nextspin.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.nextspin') }}
        //-   //- Pragmatic
        //-   .product(v-if="!['MMK', 'MMO'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots3",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots3','top=10,height=658,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-pragmatic.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.pragmatic') }}
        //-   //- Joker
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots4",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots4','top=10,height=658,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-joker.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.joker') }}

        //-   //- PG Soft
        //-   .product(v-if="!['MYR', 'SGD'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots2",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots2','top=10,height=640,width=360,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-pgsoft.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.pgs') }}
        //-   //- Simple Play
        //-   .product(v-if="['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'VND'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots5",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots5','top=10,height=528,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-simpleplay.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.simpleplay') }}
        //-   //- JILI
        //-   .product(v-if="['THB', 'MYR', 'USD'].includes(currency_code)")
        //-     router-link.suit-wrap(
        //-       to="/slots6",
        //-       target="_blank",
        //-       onclick="window.open(this.href,'slots6','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
        //-     )
        //-       .suit-image
        //-         img(src="/img/lobby/slot-jili.png?v=4")
        //-         .suit-overlay
        //-           .play-now {{ $t('ui.play_now') }}
        //-       .suite {{ $t('ui.jili') }}


    //- li#fishing.nav-item(v-if="!whiteLabel && ['MYR', 'USD', 'THB', 'MMK', 'CNY', 'IDR', 'SGD'].includes(currency_code)")
    //-   a#fishing-menu.nav-link.hover-drop(href="javascript:void(0);", data-toggle="dropdown", aria-haspopup="true", aria-expanded="false")
    //-     img.icon-menu(src="/images/menu/fish.png")
    //-     img.icon-menu-hover(src="/images/menu/fish_hover.png")
    //-     span {{ $t('ui.fishing') }}
    //-   .dropdown-menu.group-hover(aria-labelledby="fishing-menu")
    //-     .product-wrap
    //-       //--------------------------------------------------------------------
    //-       //- Fishing
    //-       //- Slash Fruit 830014
    //-       //- Happy Fish 830013
    //-       //- Legend of the Phoenix 830012
    //-       //- The Monkey King 2 830010
    //-       //- Fishing War 830009
    //-       //- God Defense 830011
    //-       //--------------------------------------------------------------------
    //-       .product
    //-         router-link.suit-wrap(
    //-           to="/slots?game=830014",
    //-           target="_blank",
    //-           onclick="window.open(this.href,'slots','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-         )
    //-           .suit-image
    //-             img(src="/img/lobby/slashfruit.png?v=4")
    //-             .suit-overlay
    //-               .play-now {{ $t('ui.play_now') }}
    //-           .suite {{ $t('ui.slashfruit') }}
    //-       .product
    //-         router-link.suit-wrap(
    //-           to="/slots?game=830013",
    //-           target="_blank",
    //-           onclick="window.open(this.href,'slots','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-         )
    //-           .suit-image
    //-             img(src="/img/lobby/happyfish.png?v=4")
    //-             .suit-overlay
    //-               .play-now {{ $t('ui.play_now') }}
    //-           .suite {{ $t('ui.happyfish') }}
    //-       .product
    //-         router-link.suit-wrap(
    //-           to="/slots?game=830012",
    //-           target="_blank",
    //-           onclick="window.open(this.href,'slots','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-         )
    //-           .suit-image
    //-             img(src="/img/lobby/legendofphoenix.png?v=4")
    //-             .suit-overlay
    //-               .play-now {{ $t('ui.play_now') }}
    //-           .suite {{ $t('ui.legendofphoenix') }}
    //-       .product
    //-         router-link.suit-wrap(
    //-           to="/slots?game=830010",
    //-           target="_blank",
    //-           onclick="window.open(this.href,'slots','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-         )
    //-           .suit-image
    //-             img(src="/img/lobby/themonkeyking2.png?v=4")
    //-             .suit-overlay
    //-               .play-now {{ $t('ui.play_now') }}
    //-           .suite {{ $t('ui.themonkeyking2') }}
    //-       .product
    //-         router-link.suit-wrap(
    //-           to="/slots?game=830009",
    //-           target="_blank",
    //-           onclick="window.open(this.href,'slots','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-         )
    //-           .suit-image
    //-             img(src="/img/lobby/fishingwar.png?v=4")
    //-             .suit-overlay
    //-               .play-now {{ $t('ui.play_now') }}
    //-           .suite {{ $t('ui.fishingwar') }}
    //-       .product
    //-         router-link.suit-wrap(
    //-           to="/slots?game=830011",
    //-           target="_blank",
    //-           onclick="window.open(this.href,'slots','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-         )
    //-           .suit-image
    //-             img(src="/img/lobby/goddefense.png?v=4")
    //-             .suit-overlay
    //-               .play-now {{ $t('ui.play_now') }}
    //-           .suite {{ $t('ui.goddefense') }}

    li#poker.nav-item(v-if="!whiteLabel && ['MYR'].includes(currency_code)")
      a#poker-menu.nav-link.hover-drop(href="javascript:void(0);", data-toggle="dropdown", aria-haspopup="true", aria-expanded="false")
        img.icon-menu(src="/images/menu/highlights.png")
        img.icon-menu-hover(src="/images/menu/highlights_hover.png")
        span {{ $t('ui.poker') }}
      .dropdown-menu.group-hover(aria-labelledby="poker-menu")
        .product-wrap
          //- DBPOKER
          .product(v-if="['MYR'].includes(currency_code)")
            router-link.suit-wrap(
              to="/slots10",
              target="_blank",
              onclick="window.open(this.href,'slots10','top=10,height=572,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;"
            )
              .suit-image
                img(src="/img/lobby/slot-dbpoker.png?v=4")
                .suit-overlay
                  .play-now {{ $t('ui.play_now') }}
              .suite {{ $t('ui.dbpoker') }}

    li.nav-item(v-if="!whiteLabel && (brand == 'WBET')")
      router-link.nav-link(to="/esports2", target="_blank", onclick="window.open(this.href,'esports2','top=10,height=768,width=1366,status=no,toolbar=no,menubar=no,location=no');return false;")
        img.icon-menu(src="/images/menu/esport.png")
        img.icon-menu-hover(src="/images/menu/esport_hover.png")
        span {{ $t('ui.e_sports') }}

    li.nav-item(v-if="!whiteLabel && w4dSupport && !mmoMode")
      router-link.nav-link(to="/w4d", target="_blank", onclick="window.open(this.href,'w4d','top=10,height=576,width=1248,status=no,toolbar=no,menubar=no,location=no');return false;")
        img.icon-menu(src="/images/menu/4d.png")
        img.icon-menu-hover(src="/images/menu/4d_hover.png")
        span {{ $t('ui.w4d') }}
</template>

<script>
import config from "@/config";
import menuList from "@/menuList";
import mixinTypes from "@/library/mixinTypes";
import naming from "@/library/_name.js";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    debugTools: () => import("@/components/desktop/debugTools"),
  },
  mixins: [mixinTypes],
  data() {
    return {
      loading: false,
      casino: {
        gp: true,
        sa: true,
        ct: true,
        evo: true,
        bg: false,
        pg: true,
        yb: true,
        e2: true,
        lcppg: true,
        ai: true,
      },
    };
  },
  computed: {
    casinoList() {
      const chunkSize = 8;
      if (menuList.casino) {
        const visibleItems = menuList.casino.filter(
          (item) =>
            !item.isHidden &&
            this.mmoMode === item.isSupportMMO &&
            (item.isNewFeatures ? this.newFeatures : true) &&
            !item.exclude.includes(this.brand)
        );
        return visibleItems.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / chunkSize);
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }
          resultArray[chunkIndex].push(item);
          return resultArray;
        }, []);
      } else {
        return [];
      }
    },
    slotsList() {
      const chunkSize = 8;
      if (menuList.slots) {
        const visibleItems = menuList.slots.filter(
          (item) =>
            !item.isHidden &&
            this.mmoMode === item.isSupportMMO &&
            (item.isNewFeatures ? this.newFeatures : true) &&
            !item.exclude.includes(this.brand) &&
            item.currency.includes(this.currency_code)
        );
        return visibleItems.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / chunkSize);
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }
          resultArray[chunkIndex].push(item);
          return resultArray;
        }, []);
      } else {
        return [];
      }
    },

    brand() {
      return config.brand;
    },
    newFeatures() {
      return config.newFeatures;
    },
    currentList() {
      return config.currentList;
    },
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    // sacasino() {
    //   return config.sacasino;
    // },
    w4dSupport() {
      return config.w4dSupport;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
  },
  destroyed() {},
  mounted() {},
  methods: {
    openWindow(name, height, width) {
      window.open(this.$router.resolve({ name }).href, name, `top=10,height=${height},width=${width},status=no,toolbar=no,menubar=no,location=no`);
    },
    setMenu2(e) {
      // console.log("menuBar.setMenu2");
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = "today";
      mi5["menu2"] = e;
      mi5["menu3"] = "hdpou";
      var changed = false;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menuY"] != this.menuY) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        this.resetSelectLeague();
        this.clearSearch();
        mi5["src"] = "menuBar.setMenu2";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE");
        $(".market-menu").removeClass("active");
      }
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
  },
};
</script>
